import classJoin from 'classjoin';
import {Component, h} from 'preact';
import {StateVisualMapItem} from './Store/State';

/**
 * Component Properties.
 */
interface MobileVisualItemsListProps
{
	/** Подпись */
	label: string;
	/** Элементы списка */
	items: StateVisualMapItem[];
	/**
	 * Обработчик изменения значения.
	 * 
	 * @param value Новое значение.
	 */
	onChange( value: string ): void;
}

/**
 * Component State.
 */
interface MobileVisualItemsListState
{
	[key: string]: void;
}

/**
 * Список элементов мобильного режима визуального выборщика.
 */
class MobileVisualItemsList
	extends Component<MobileVisualItemsListProps, MobileVisualItemsListState>
{
	/**
	 * Render component.
	 */
	public render( {label, items}: MobileVisualItemsListProps ): JSX.Element
	{
		return (
			<div class="items-list">
				<p class="label">
					{label}
				</p>
				<ul onClick={this.onItemsClick}>
					{items.map(
						( item ) => (
							<li
								class={classJoin( {disabled: item.available === 0} )}
								data-value={item.target}
							>
								{item.target}
							</li>
						),
					)}
				</ul>
			</div>
		);
	}
	
	/**
	 * При нажатии на элемент списка.
	 */
	private onItemsClick = ( event: Event ): void =>
	{
		const target = event.target as HTMLElement;
		
		if (
			( target.tagName !== 'LI' )
			|| target.classList.contains( 'disabled' )
		)
		{
			return;
		}
		
		const value = target.dataset.value;
		
		if ( value )
		{
			this.props.onChange( value );
		}
	}
	
}

/**
 * Module.
 */
export {
	MobileVisualItemsList as default,
	MobileVisualItemsListProps,
	MobileVisualItemsListState,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/MobileVisualItemsList.tsx